import { produce } from 'immer'
import { mountStoreDevtool } from 'simple-zustand-devtools'
import { create } from 'zustand'

type NewPlatformFormState = {
	currentStep: number
	isFormValid: boolean
	formValues: Record<string, any>
}

type NewPlatformFormActions = {
	actions: {
		clearFormValues: () => void
		setFormValues: (fieldName: string, value: any) => void
		setFormValidity: (isValid: boolean) => void
		setCurrentStep: (step: number) => void
	}
}

const initialFormValues = {
	environment: '',
	deployment: '',
	dataClassification: '',
	tierLevel: '',
	platformViewer: [],
	region:'asia-southeast1',
	platformName: '',
	platformOwner: '',
	platformOwnerEmail: '',
	systemAlias:'',
	wbsCode: '',
	costCenter: '',
	group: '',
	tagsID: '',
	creationTime: '',
	inheritGcpTagsBool: false,
	isClusterDetailsFilled: false
}

const newPlatformFromStore = create<
	NewPlatformFormState & NewPlatformFormActions
>((set, _get) => ({
	currentStep: 0,
	isFormValid: false,
	formValues: initialFormValues,
	actions: {
		clearFormValues: () => set(() => ({ formValues: initialFormValues })),

		setFormValidity: (isValid) => set(() => ({ isFormValid: isValid })),

		setFormValues: (fieldName, value) =>
			set((state) =>
				produce(state, (draft) => {
					if (fieldName === 'platformViewer') {
						const emailValues = Array.isArray(value)
							? value
							: String(value ?? '').split(',')
						const emails = emailValues
							.map((email) => String(email ?? '').trim())
							.filter(Boolean)
						draft.formValues[fieldName] = emails
					} else {
						draft.formValues[fieldName] = value
					}

					if (fieldName === 'group') {
						draft.formValues[fieldName] =
							value && typeof value === 'object' && 'value' in value
								? value.value
								: value ?? ''
					}
				})
			),
		setCurrentStep: (step) => {
			set(() => ({
				currentStep: step
			}))
		}
	}
}))

export const useNewPlatformFormStore = () =>
	newPlatformFromStore((state) => state)

if (process.env.NODE_ENV !== 'production') {
	mountStoreDevtool('NewPlatformFormStore', newPlatformFromStore)
}
